import { PlayerService } from "./PlayerService";

type checkAnswerResponse = {
    correct: boolean;
};

export class ThrillerDanceService {
    private _playerService: PlayerService = new PlayerService();
    public async checkAnswer(answer: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}eva/check-puzzle/${answer}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }
        );
        const data: checkAnswerResponse = await response.json() as checkAnswerResponse;

        return data.correct;
    }
}
